import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import QRCode from "qrcode";
import JsBarcode from "jsbarcode";

export default function ScanCodeScreen() {
  const nav = useNavigate();
  const { state } = useLocation();
  const canvasRef = useRef(null);
  const svgRef = useRef(null);
  const [wakeLock, setWakeLock] = useState(null);

  const payload = useMemo(() => {
    // state attendu: { name, kind, value }
    return state || {};
  }, [state]);

  useEffect(() => {
    if (!payload?.value || !payload?.kind) return;

    const run = async () => {
      // Wake Lock (best effort)
      try {
        if ("wakeLock" in navigator) {
          const wl = await navigator.wakeLock.request("screen");
          setWakeLock(wl);
        }
      } catch (e) {
        // ignore
      }

      // Render
      if (payload.kind === "qr") {
        if (!canvasRef.current) return;
        await QRCode.toCanvas(canvasRef.current, payload.value, {
          margin: 2,
          scale: 12, // gros pour scan écran
          errorCorrectionLevel: "M",
        });
      } else {
        if (!svgRef.current) return;
        JsBarcode(svgRef.current, payload.value, {
          format: "CODE128",
          lineColor: "#000",
          width: 3,
          height: 220,
          displayValue: false,
          margin: 10,
        });
      }
    };

    run();

    return () => {
      try { wakeLock?.release?.(); } catch {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload?.kind, payload?.value]);

  const goFullscreen = async () => {
    try {
      await document.documentElement.requestFullscreen();
    } catch {}
  };

  if (!payload?.value || !payload?.kind) {
    return (
      <div style={{ padding: 24 }}>
        <h2>Scan mode</h2>
        <p>Aucun code à afficher (navigation sans state).</p>
        <button onClick={() => nav(-1)}>Retour</button>
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        background: "#fff",
        color: "#111",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          padding: 12,
          display: "flex",
          alignItems: "center",
          gap: 8,
          borderBottom: "1px solid #eee",
        }}
      >
        <strong style={{ flex: 1 }}>{payload.name || "Scan mode"}</strong>

        <button onClick={goFullscreen} style={{ padding: "8px 12px" }}>
          Plein écran
        </button>

        <button onClick={() => nav(-1)} style={{ padding: "8px 12px" }}>
          Fermer
        </button>
      </div>

      <div
        style={{
          flex: 1,
          display: "grid",
          placeItems: "center",
          padding: 16,
        }}
      >
        {payload.kind === "qr" ? (
          <canvas ref={canvasRef} style={{ maxWidth: "95vw", maxHeight: "80vh" }} />
        ) : (
          <svg ref={svgRef} />
        )}
      </div>

      {/* Debug utile (tu peux virer) */}
      <div style={{ padding: 12, borderTop: "1px solid #eee", fontSize: 12 }}>
        <div style={{ opacity: 0.7 }}>Contenu :</div>
        <div style={{ wordBreak: 'break-all', whiteSpace: 'pre-wrap' }}>
          {JSON.stringify(payload.value)}
        </div>
      </div>
    </div>
  );
}